import React from "react";
import Milestones from "./components/Milestones";
import StayInformed from "../../shared/components/StayInformed";

const Milestone = () => {
  return (
    <>
      <Milestones />
      <StayInformed />
    </>
  );
};

export default Milestone;
